// removed by extract-text-webpack-plugin
module.exports = {"ManageButton":"_1skILRmBjsC2uer9R83g1m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/DeleteButton/index.css
// module id = 854
// module chunks = 0